export default "<div kendoTooltip #anchor showOn=\"none\" position=\"bottom\" [tooltipClass]=\"bg-danger\" title=\"Missing / Invalid\" ></div>"